export enum SEO_IDS {
  LANG = 'seo-lang',
  OG_LOCALE = 'seo-og-locale',
  OG_SITENAME = 'seo-og-sitename',
  TWITTER_CARD = 'seo-twitter-card',
  TWITTER_SITE = 'seo-twitter-site',
  TWITTER_SITE_ID = 'seo-site-id',
  TWITTER_CREATOR = 'seo-twitter-creator',
  TWITTER_CREATOR_ID = 'seo-twitter-creator-id',
  FB_ADMINS_ID = 'seo-admins-id',
  GOOGLE_SITE_VERIFICATION = 'seo-google-site-verification',
  TITLE = 'seo-title',
  OG_TITLE = 'seo-og-title',
  TWITTER_TITLE = 'seo-twitter-title',
  DESCRIPTION = 'seo-description',
  OG_DESCRIPTION = 'seo-og-description',
  TWITTER_DESCRIPTION = 'seo-twitter-description',
  ARTICLE_PUBLISHED_TIME = 'seo-article-published-time',
  ARTICLE_MODIFIED_TIME = 'seo-article-modified-time',
  ARTICLE_AUTHOR = 'seo-article-author',
  OG_URL = 'seo-og-url',
  CANONICAL = 'seo-canonical',
  OG_TYPE = 'seo-og-type',
  ROBOTS = 'seo-robots',
}
